import React, { useCallback, useContext, useEffect, useState } from "react";
import DynamicForm from "../components/DynamicForm";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  dang_ky_nhan_hieu,
  dang_ky_kieu_dang_cong_nghiep,
  dang_ky_sang_che_giai_phap_huu_ich,
  dang_ky_gia_han,
  dang_ky_sua_doi_don_van_bang,
  chuyen_giao_chuyen_nhuong_don_van_bang,
  tra_cuu_thong_tin,
  dang_ky_ban_quyen,
  dich_vu_khac,
} from "../quan-ly-khach-hang/components/data/form_data";
import { AuthContext } from "../../../contexts/AuthContext";
import Loading from "../components/Loading";
import { serviceService } from "../../../services/api/serviceService";
const CreateNewService = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { id, slug, serviceId } = useParams();
  const { token } = useContext(AuthContext);
  const [formData, setFormData] = useState([]);
  const [serviceName, setServiceName] = useState("");
  const [category, setCategory] = useState("");

  const fetchService = useCallback(
    async (category_id) => {
      try {
        setLoading(true);
        switch (category_id) {
          case "dang-ky-nhan-hieu":
            setFormData(dang_ky_nhan_hieu);
            break;
          case "dang-ky-kieu-dang-cong-nghiep":
            setFormData(dang_ky_kieu_dang_cong_nghiep);
            break;
          case "dang-ky-sang-che-giai-phap-huu-ich":
            setFormData(dang_ky_sang_che_giai_phap_huu_ich);
            break;
          case "dang-ky-gia-han":
            setFormData(dang_ky_gia_han);
            break;
          case "dang-ky-sua-doi-don-van-bang":
            setFormData(dang_ky_sua_doi_don_van_bang);
            break;
          case "chuyen-giao-chuyen-nhuong-don-van-bang":
            setFormData(chuyen_giao_chuyen_nhuong_don_van_bang);
            break;
          case "tra-cuu-thong-tin":
            setFormData(tra_cuu_thong_tin);
            break;
          case "dang-ky-ban-quyen":
            setFormData(dang_ky_ban_quyen);
            break;
          case "dich-vu-khac":
            setFormData(dich_vu_khac);
            break;
          default:
            toast.error("Không tồn tại form có tên như trên!!");
            navigate("/");
        }
      } catch (error) {
        toast.dismiss();
        toast.error(
          error.response
            ? `${error.response?.data?.message}`
            : "Không thể kết nối tới server. Vui lòng kiểm tra mạng."
        );
        console.error("Error:", error);
      } finally {
        setLoading(false);
      }
    },
    [navigate]
  );

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await serviceService.get_by_id(serviceId, token);
      setCategory(response.category.categoryName);
      setServiceName(response.serviceName);
    } catch (error) {
      toast.dismiss();
      toast.error("Lỗi khi lấy dịch vụ từ server");
    } finally {
      setLoading(false);
    }
  }, [serviceId, token]);

  useEffect(() => {
    fetchService(slug);
    fetchData();
  }, [fetchService, fetchData, slug]);

  if (loading) {
    return (
      <div className="flex h-full items-center justify-center">
        <Loading />
      </div>
    );
  }

  return (
    <DynamicForm
      formData={formData}
      id={id}
      token={token}
      serviceId={serviceId}
      category={category}
      serviceName={serviceName}
    />
  );
};

export default CreateNewService;
